/**
 * Video module.
 * @author Dayne Coulson-Hoffacker
 */
export default class VideoModule {
  /**
   * Constructs a new counter component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.cta = this.element.querySelector('.cta')
    this.videoContainer = document.querySelector('.video-player')
    this.closeButton = this.videoContainer.querySelector('.close-icon')
    this.MoveMyPointsSection = document.querySelector('#move-my-points')
    this.video = this.element.querySelector('video')

    this.cta.addEventListener('click', () => {
      this.videoContainer.classList.add('visible')
      document.body.classList.add('locked')
      if (this.MoveMyPointsSection) {
        this.MoveMyPointsSection.classList.add('locked')
      }
    })

    this.closeButton.addEventListener('click', () => {
      this.videoContainer.classList.remove('visible')
      document.body.classList.remove('locked')
      this.video.pause()
      this.video.currentTime = 0
    })

  }
}



// WEBPACK FOOTER //
// ./components/video-module/index.js